import { useState } from "react";
import API from "../services/api";
import { useNavigate, Link } from "react-router-dom";
import "./Login.css";

const Login = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const res = await API.post("/auth/login", formData);
      if (res.data?.access_token) {
        localStorage.setItem("token", res.data.access_token);
      }
      navigate("/dashboard");
    } catch (err) {
      alert(err.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-grid">
        {/* LEFT SIDE */}
        <div className="login-left">
          <h1 className="login-title">
            🚀 Limited MVP Access <span className="highlight">— Feedback & Testing Only</span>
          </h1>
          <p className="login-subtitle">
            Access your Intel dashboard to unlock these core features:
          </p>
          <ul className="login-features">
            <li><strong>Overview</strong> — Track market trends and creator performance at a glance.</li>
            <li><strong>Compare Creators</strong> — Benchmark creators side‑by‑side with real data.</li>
            <li><strong>Agency Requests</strong> — Submit custom research requests tailored to your needs.</li>
            <li><strong>Agency Feedback</strong> — Influence future intelligence by sharing insights.</li>
            <li><strong>Views Ranking</strong> — Identify high‑impact creators ranked by audience views.</li>
            <li><strong>Research Process</strong> — Transparent methodology behind every CY score.</li>
          </ul>
          <p className="login-note">
            This MVP is limited to select agencies for testing and feedback.
          </p>
        


        </div>

        {/* RIGHT SIDE */}
        <div className="login-card">
          <div className="login-header">
            <h2>Welcome Back</h2>
            <p>Login to your creator account</p>
          </div>

          <form onSubmit={handleLogin} className="login-form">
            <div>
              <label>Email Address</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter your email"
                required
              />
            </div>

            <div>
              <label>Password</label>
              <div className="password-wrapper">
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="Enter password"
                  required
                />
                <span onClick={() => setShowPassword(!showPassword)} className="toggle-password">
                  {showPassword ? "🙈 Hide" : "👁️ Show"}
                </span>
              </div>
            </div>

            <div className="forgot-password">
              <Link to="/forgot-password">Forgot password?</Link>
            </div>

            <button type="submit" disabled={loading} className="login-btn">
              {loading ? "Logging in..." : " Limited Login"}
            </button>
          </form>

          <div className="signup-link">
            Don’t have an account?{" "}
            <Link to="/signup" className="signup-btn">Request Access</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
